/**
 * @ngdoc directives
 * @memberof mercury.modules.time
 * @name tags
 */
angular.module('mercury.modules.time.roster')
.directive('tags', ["$timeout", function($timeout) {
  return {
    restrict: 'A',
    scope: {
      tags: '=ngModel',
      acOptions: '=tagsAutocomplete'
    },
    template: '<div ng-class="{\'tags-container\': !inputDisabled}" ng-click="focusInput(); $event.stopPropagation()">' +
    '<span ng-repeat="tag in tagsArray track by $index" class="label label-default">' +
    '{{tag}}<span ng-hide="inputDisabled" ng-click="removeTag($index); $event.stopPropagation()">&times;</span></span>' +
    '<input ng-hide="inputDisabled" ng-keyup="inputChange($event)" ng-blur="inputBlur()" ng-focus="inputFocus()">',
    link: function(scope, element, attrs) {
      scope.tagsArray = (scope.tags) ? JSON.parse(scope.tags) : [];

      scope.inputDisabled = attrs.disabled ? JSON.parse(attrs.disabled) : false;

      var updateModel = function() {
        if (scope.tagsArray.length === 0) {
          scope.tags = '';
        } else {
          scope.tags = JSON.stringify(scope.tagsArray);
        }
      };

      scope.removeTag = function(index) {
        scope.tagsArray.splice(index, 1);
        updateModel();
      };

      var inputValue = function(newValue) {
        if (angular.isDefined(newValue)) {
          element.find('input').val(newValue);
        } else {
          return element.find('input').val();
        }
      };

      var emptyInput = true;
      scope.inputChange = function(e) {
        if (e.keyCode == '13' && !emptyInput) {//enter
          scope.tagsArray.push(inputValue());
          updateModel();

          inputValue('');

          emptyInput = true;
        } else if (e.keyCode == '8' && emptyInput) {//backspace
          scope.tagsArray.splice(-1, 1);
          updateModel();
        } else if (inputValue().length === 0) {
          emptyInput = true;
        } else {
          emptyInput = false;
        }

      };

      scope.inputBlur = function() {
        if (inputValue() !== '') {
          scope.tagsArray.push(inputValue());
          updateModel();

          inputValue('');

          emptyInput = true;
        }
      };

      if (angular.isDefined(attrs.tagsAutocomplete)) {
        element.find('input').autocomplete({
          minLength: 1,
          delay: 0,
          autoFocus: true,
          source: function(req, res) {
            var options = [];
            angular.forEach(scope.acOptions, function(opt) {
              if (typeof opt == 'string' && (req.term === '' || opt.toLowerCase().indexOf(req.term.toLowerCase()) !== -1)) {
                options.push(opt);
              }
            });

            res(options.slice(0, 10));
          },
          select: function(e, ui) {
            $timeout(function() {
              scope.tagsArray.push(ui.item.value);
              updateModel();

              inputValue('');
              emptyInput = true;
            });
          }
        });

        scope.inputFocus = function() {
          $timeout(function() {
            element.find('input').autocomplete('search', '');
          });
        };
      }

      scope.focusInput = function() {
        $timeout(function() {
          element.find('input').focus();
        });
      };
    }
  };
}]);
